export default __webpack_public_path__ + "static/media/lottery1.a2b58cdf.jpg";